import _ from 'es-toolkit/compat';

import type { Nullable } from '@clearverify/types';

import type { UserUpdate } from 'src/api';

import { PersonalInformationFormFields, PersonalInformationFormValues } from '../types';

export const prepareConsumerPersonalInformationData = (
  data: PersonalInformationFormValues,
  homeAddressId: Nullable<string>,
): UserUpdate => {
  return {
    ..._.omit(data, [PersonalInformationFormFields.homeAddress]),
    ...(homeAddressId
      ? {
          address: {
            update: data.homeAddress,
          },
        }
      : {
          address: {
            create: data.homeAddress,
          },
        }),
  };
};
